import { Button, Icon, Text } from "@ttc3k/trekker";
import { EyeSolid } from "iconoir-react";
import { Collapsible } from "shared/components/molecules";
import { Flex } from "styled-system/jsx";
import { useImpersonation } from "shared/contextProviders/impersonation";
import { useNavigate } from "react-router";
import { formatRenewalDate } from "shared/utils/formatDate";

export const ImpersonationBanner = () => {
  const {
    isImpersonating,
    impersonatedDisplayName,
    impersonationKind,
    impersonationReturnTo,
    impersonationSimulatedDate,
    stopImpersonation,
  } = useImpersonation();
  const navigate = useNavigate();
  const isTestSession = impersonationKind === "test";

  const handleStop = () => {
    const returnTo = impersonationReturnTo;
    stopImpersonation();
    if (isTestSession) {
      // The in-memory user, organizations, and Apollo cache all belong to the
      // test user, so reload instead of navigating to avoid rendering the org
      // page before the admin's data is back.
      window.location.assign(returnTo || "/app");
      return;
    }
    navigate("/app");
  };

  return (
    <Collapsible open={isImpersonating}>
      <Flex
        w="full"
        h="48px"
        bg="linear-gradient(90deg, #DC2626 0%, #E11D48 100%)"
        justifyContent="space-between"
        alignItems="center"
        px="300"
      >
        <Flex gap="150" alignItems="center" color="white">
          <Icon Element={EyeSolid} size="sm" css={{ opacity: 0.75 }} />
          <Text visual="bodyMedium">
            {isTestSession ? "Testing as" : "Impersonation Mode"}
          </Text>
          {impersonatedDisplayName && (
            <Text visual="body" css={{ opacity: 0.85 }}>
              — {impersonatedDisplayName}
            </Text>
          )}
          {isTestSession && impersonationSimulatedDate && (
            <Text visual="body" css={{ opacity: 0.85 }}>
              · as of{" "}
              {formatRenewalDate(
                new Date(`${impersonationSimulatedDate}T12:00:00Z`),
                "MMM d, yyyy",
              )}
            </Text>
          )}
        </Flex>

        <Button
          visual="unstyled"
          color="white"
          _hover={{ color: "white/75" }}
          onClick={handleStop}
        >
          <Text visual="smallMedium">
            {isTestSession ? "Stop testing" : "Stop Impersonating"}
          </Text>
        </Button>
      </Flex>
    </Collapsible>
  );
};
